import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Home from './pages/Home';
import Commercial from './pages/Commercial';
import Residential from './pages/Residential';
import Contact from './pages/Contact';
import Article from './pages/Article';
import Navbar from './components/Navbar';
import Footer from './components/Footer';

export default function App() {
  return (
    <HelmetProvider>
    <BrowserRouter>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/commercial" element={<Commercial />} />
        <Route path="/residential" element={<Residential />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/blog/:slug" element={<Article />} />
      </Routes>
      <Footer />
    </BrowserRouter>
    </HelmetProvider>
  );
}
